import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Divider, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { ArrowDropDown as ArrowDropDownIcon, MoreHoriz as MoreIcon } from '@mui/icons-material';

/**
 * "More" button for a page header with more actions than fit beside the
 * title. `items` are `{ label, icon, to | onClick, danger, hidden }`; a
 * danger item (Delete) goes last, under a divider, in the error colour.
 */
const MoreMenu = ({ items, label = 'More' }) => {
  const [anchor, setAnchor] = useState(null);
  const shown = items.filter((item) => item && !item.hidden);
  if (shown.length === 0) return null;
  const close = () => setAnchor(null);
  const regular = shown.filter((item) => !item.danger);
  const danger = shown.filter((item) => item.danger);

  const renderItem = ({ label: text, icon: Icon, to, onClick, danger: isDanger }) => (
    <MenuItem
      key={text}
      {...(to ? { component: RouterLink, to } : {})}
      onClick={() => {
        close();
        onClick?.();
      }}
      sx={isDanger ? { color: 'error.main' } : undefined}
    >
      {Icon && (
        <ListItemIcon sx={isDanger ? { color: 'error.main' } : undefined}>
          <Icon fontSize="small" />
        </ListItemIcon>
      )}
      <ListItemText primary={text} />
    </MenuItem>
  );

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<MoreIcon />}
        endIcon={<ArrowDropDownIcon />}
        onClick={(e) => setAnchor(e.currentTarget)}
        aria-haspopup="menu"
        aria-expanded={Boolean(anchor)}
      >
        {label}
      </Button>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={close}>
        {regular.map(renderItem)}
        {regular.length > 0 && danger.length > 0 && <Divider />}
        {danger.map(renderItem)}
      </Menu>
    </>
  );
};

export default MoreMenu;
